import React from 'react';
import {
  SButton,
  SIcon,
  type SButtonProps,
  type SIconName,
} from '@chargebee/sting-react';
import { cs } from '@bbkAdminUtils/css-utils';

type SaveButtonProps = Omit<SButtonProps, 'variant' | 'icon'> & {
  iconName?: SIconName;
  showIcon?: boolean;
};

/** Primary save/done action with check icon (editor top bars, commits). */
export const SaveButton: React.FC<SaveButtonProps> = ({
  iconName = 'check',
  showIcon = true,
  children,
  className,
  ...props
}) => (
  <SButton
    variant="primary"
    icon={showIcon ? <SIcon name={iconName} /> : undefined}
    className={cs('tw-flex tw-items-center', className)}
    {...props}
  >
    {children}
  </SButton>
);

type RevertButtonProps = Omit<SButtonProps, 'variant' | 'icon'> & {
  label?: string;
};

/** Secondary revert/reset action with rotate icon (pairs with {@link SaveButton}). */
export const RevertButton: React.FC<RevertButtonProps> = ({
  label = 'Revert',
  children,
  className,
  ...props
}) => (
  <SButton
    variant="neutral-outline"
    icon={<SIcon name="rotate-ccw" />}
    className={cs('tw-flex tw-items-center', className)}
    {...props}
  >
    {children ?? label}
  </SButton>
);
